import React from 'react';

const Loader = ({ size = '80px', style = {}, divStyle = {} }) => {
  return (
    <div className='' style={divStyle}>
      <img 
        src={require('../../../images/balls.gif')} 
        alt='loading...' 
        style={{ height: size, ...style }}
      />
    </div>
  );
};

export default Loader;